import { ReactElement } from 'react';
import { LoadingGradient } from '@provider-directory/components/loading-gradient/loading-gradient.component';

const list = new Array(8).fill(0);

export const ProviderSearchResultsSkeleton = (): ReactElement => {
  return (
    <div
      data-testid={'provider-search-skeleton'}
      className={'flex flex-col gap-y-4'}
    >
      {list.map((_, i) => (
        <LoadingGradient className={'h-72 w-full rounded-lg'} key={i} />
      ))}
    </div>
  );
};
